var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delete-text cursor-pointer fz-12",on:{"click":function($event){return _vm.onDelete(_vm.row)}}},[_vm._v("\n\t移除\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }